import { Modal } from "react-bootstrap";
import ButtonElement from "./ButtonElement";

const ModalElement = ({ show, onHide, children, title, size = "lg", FooterComponent, height }) => {
    return <Modal className={size == "full" ? "full-modal" : `modal-${size}`} show={show} backdrop="static" onHide={onHide} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header style={{
            position: "sticky",
            top: "0",
            zIndex: "1000",
            backgroundColor: "white",
            borderBottom: "1px solid #dee2e6"
        }} className="border-0 d-flex flex-column justify-content-start pb-0">
            <div className="d-flex justify-content-between align-items-start w-100">
                <div className="w-100 text-center" style={{ visibility: title ? "visible" : "hidden" }}>
                    <h3 className="pt-3">{title}</h3>
                </div>
                <ButtonElement variant="btn-close" onClick={onHide}></ButtonElement>
            </div>
        </Modal.Header>
        <Modal.Body className="p-4 text-center" style={{
            overflowY: "auto",
        }}>
            {children}
        </Modal.Body>
        {FooterComponent && (
            <Modal.Footer className="border-top" style={{
                justifyContent: "center",
                position: "sticky",
                bottom: "0",
                backgroundColor: "white",
                margin: "0",
                padding: "1rem",
                zIndex: "1000",
                flexShrink: "0"
            }}>
                {FooterComponent}
            </Modal.Footer>
        )}
    </Modal>
}

export default ModalElement;